export default ({ imageUrl }) => ({
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundImage: `url(${imageUrl})`,
    borderRadius: '4px',
});
